// src/components/CustomTabs.tsx
import React from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";

type TabOption = {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  activeIcon?: React.ReactNode;
};

type CustomTabsProps = {
  tabs: TabOption[];
  value: string | number;
  onChange: any;
};

export const CustomTabs: React.FC<CustomTabsProps> = ({
  tabs,
  value,
  onChange,
}) => {
  return (
    <Box sx={{ width: "fit-content" }}>
      <Tabs
        value={value}
        onChange={onChange}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        TabIndicatorProps={{ style: { display: "none" } }}
        TabScrollButtonProps={{ style: { color: "white" } }}
        aria-label="custom scrollable tabs"
        // visibleScrollbar={true}
        sx={{
          // borderColor: "divider",
          // fontWeight: "500",
          // flex: 1,
          color: "white",
          width: "100%",
          minHeight: "fit-content",
          "& .MuiTabs-flexContainer": {
            display: "flex",
            // flexDirection: "row",
            gap: "12px",
            padding: "0px",
          },
        }}
      >
        {tabs.map((tab) => {
          const isActive = value === tab.value;
          return (
            <Tab
              key={tab.value}
              disableRipple
              sx={{
                textTransform: "none",
                fontWeight: "500",
                color: "white",
                padding: "0px !important",
              }}
              label={
                <Box
                  sx={{
                    boxShadow: isActive
                      ? "inset 0px 0px 0px 1px #CCFF00"
                      : "inset 0px 0px 0px 1px #3D3D3D",
                    bgcolor: isActive ? "#CCFF00" : "#141414",
                    color: isActive ? "black" : "#8B8B8B",
                    borderRadius: "100px",
                    minHeight: "46px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "12px 16px",
                  }}
                >
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: tab.icon || tab.activeIcon ? "8px" : 0, // only add gap if icon present
                      fontSize: "16px",
                      lineHeight: "22px",
                    }}
                    fontWeight={600}
                  >
                    {isActive ? tab.activeIcon : tab.icon}
                    {tab.label}
                  </Typography>
                </Box>
              }
            />
          );
        })}
      </Tabs>
    </Box>
  );
};
